module.exports = __webpack_public_path__ + "fa-regular-400.ttf?bdd14bcd205c27612b5bfe322ea6598a";